import React from 'react';
import BGImg from '../assets/img/BGImg.png'
import BGImgElipse from '../assets/img/BGImgEclipse.png'
import {ReactComponent as RoundLOGO} from '../assets/RoundLOGO.svg'
import {ReactComponent as RoundLOGOsmall} from '../assets/RoundLogoSmall.svg'
import Box from "@mui/material/Box";
// import Fab from '@mui/material/Fab';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
// import { useNavigate } from "react-router-dom";
import { Outlet} from 'react-router-dom';



const AuthenticationPage = () => {
// const navigate = useNavigate()
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'))
    
    // const handleClick = () =>{
    //     navigate('/')
    // }
    return (
        <Box sx={{
            backgroundColor: '#fff',
            height: '100vh',
            margin: 0,
            padding: 0,
            backgroundImage: `url(${BGImg}), url(${BGImgElipse})`,
            backgroundRepeat: 'no-repeat, no-repeat',
            backgroundPosition: {xs: 'top 0 right -60px', sm: 'right 0 top 0, left -15% bottom -20%'},
            backgroundSize: {xs: '976px 100%, 0 0', sm: '976px 100%, 362px 362px'},
            display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
            <Box sx={{display: 'flex', flexDirection: 'column', width: {xs: '60%', sm: '30%'},}}>
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
                    {matches ? <RoundLOGO/> : <RoundLOGOsmall/>}
                </Box>
                <Outlet />
                {/*<Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',marginTop: 8}}>*/}
                {/*    <Fab size='medium' color='primary' aria-label='add' onClick={handleClick}>*/}
                {/*        <ArrowBackIcon />*/}
                {/*    </Fab>*/}
                {/*</Box>*/}
            </Box>
        </Box>
    );
};

export default AuthenticationPage;